import { render, staticRenderFns } from "./RmSurveyOptionList.vue?vue&type=template&id=547ebe01&scoped=true"
import script from "./RmSurveyOptionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmSurveyOptionList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RmSurveyOptionList.vue?vue&type=style&index=0&id=547ebe01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547ebe01",
  null
  
)

export default component.exports